import { HStack, VStack } from 'ui/Layout';
import { Text } from 'ui/Typography';

type Props = {
  title: string;
  description: React.ReactNode;
  control: React.ReactNode;
};

const DialogSetting: React.FC<Props> = ({ title, description, control }) => (
  <HStack alignItems="center" justifyContent="space-between" gap={8}>
    <VStack alignItems="flex-start" gap={0.5}>
      <Text fontWeight="medium">{title}</Text>
      <Text color="gray.600" fontSize="xs">
        {description}
      </Text>
    </VStack>
    <VStack alignItems="flex-end" minW="145px" w="170px">
      {control}
    </VStack>
  </HStack>
);

export default DialogSetting;
